module.exports = __webpack_public_path__ + "img/Left Back Locker.cc2e797e.png";